// extracted by mini-css-extract-plugin
export var mainContainer = "index-module--mainContainer--3ZBwx";
export var backwardButton = "index-module--backwardButton--KXkgy";
export var forwardButton = "index-module--forwardButton--3E1-M";
export var section = "index-module--section--3-UXH";
export var carrousel = "index-module--carrousel--36HKq";
export var carrousel_item = "index-module--carrousel_item--2bokD";
export var carrousel_imgContainer = "index-module--carrousel_imgContainer--ug0WR";
export var carrousel_titleContainer = "index-module--carrousel_titleContainer--3NwQG";
export var carrousel_title = "index-module--carrousel_title--1m3q9";